/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Disbursement - need to be refactored
 */
import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { ClaimFundData, RegistrationData } from '../types';
import { ACTION_TYPES } from './types';

export type SubmitClaimFundState = {
  loading: boolean;
  success: boolean;
  error: string;
  submitted: boolean;
};

export type FetchClaimFundListState = {
  data: {
    data: ClaimFundData[];
    total: number;
  };
  success: boolean;
  error: string;
  status_code: string;
  reason: string;
  loading: boolean;
};

export type ClaimFundDetailState = {
  data: ClaimFundData | null;
  error: string;
  status_code: string;
  reason: string;
  success: boolean;
  loading: boolean;
};

export type RegisterClaimFundState = {
  data: RegistrationData | null;
  error: string;
  success: boolean;
  loading: boolean;
  fetched: boolean;
};

export type InquiryResultState = {
  data: {
    account_name: string;
  };
  success: boolean;
  loading: boolean;
  submitted: boolean;
};

export type ClaimFundAddUserDataState = {
  success: boolean;
  status_code: string;
  submitted: boolean;
  loading: boolean;
};

export type ClaimFundActionState = {
  success: boolean;
  error: string;
  submitted: boolean;
  loading: boolean;
  reason: string;
};

export type SelectBankState = {
  bank_code: string;
  bank_name: string;
};

export type ClaimFundState = {
  submit: SubmitClaimFundState;
  fetch: FetchClaimFundListState;
  detail: ClaimFundDetailState;
  registration: RegisterClaimFundState;
  inquiry: InquiryResultState;
  addUserData: ClaimFundAddUserDataState;
  action: ClaimFundActionState;
  selectBank: SelectBankState;
};

const initialState: ClaimFundState = {
  // TODO: Set to default value after integration with API
  fetch: {
    data: {
      total: 0,
      data: [],
    },
    success: false,
    error: '',
    status_code: '',
    reason: '',
    loading: false,
  },
  submit: {
    loading: false,
    success: false,
    error: '',
    submitted: false,
  },
  detail: {
    data: null,
    success: true,
    error: '',
    status_code: '',
    reason: '',
    loading: false,
  },
  registration: {
    data: null,
    success: false,
    error: '',
    loading: false,
    fetched: false,
  },
  inquiry: {
    data: {
      account_name: '',
    },
    success: true,
    loading: false,
    submitted: false,
  },
  addUserData: {
    success: false,
    submitted: false,
    status_code: '',
    loading: false,
  },
  action: {
    success: false,
    submitted: false,
    loading: false,
    error: '',
    reason: '',
  },
  selectBank: {
    bank_code: '',
    bank_name: '',
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.CLAIM_FUND_RESET_SUBMIT:
      return update(state, {
        $merge: {
          submit: initialState.submit,
        },
      });
    case ACTION_TYPES.CLAIM_FUND_SUBMIT:
      return update(state, {
        submit: {
          $merge: {
            loading: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_SUBMIT_SUCCESS:
    case ACTION_TYPES.CLAIM_FUND_SUBMIT_FAILED:
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            submitted: true,
            success: payload.success,
            error: payload.error,
          },
        },
      });
      return update(state, {
        fetch: {
          $merge: {
            data: {
              total: 0,
              data: [],
            },
            success: payload.success,
            loading: false,
            status_code: payload.status_code,
            error: payload.error,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_FETCH_DETAIL:
      return update(state, {
        detail: {
          $merge: {
            loading: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_FETCH_DETAIL_SUCCESS:
      return update(state, {
        detail: {
          $merge: {
            data: payload.data,
            loading: false,
            success: payload.success,
            status_code: payload.status_code,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_FETCH_DETAIL_FAILED:
      return update(state, {
        detail: {
          $merge: {
            loading: false,
            success: payload.success,
            status_code: payload.status_code,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_ACTION:
      return update(state, {
        action: {
          $merge: {
            loading: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_ACTION_SUCCESS:
    case ACTION_TYPES.CLAIM_FUND_ACTION_FAILED:
      return update(state, {
        action: {
          $merge: {
            loading: false,
            submitted: true,
            success: payload.success,
            error: payload.error,
            reason: payload.reason,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_ACTION_RESET:
      return update(state, {
        $merge: {
          action: initialState.action,
        },
      });
    case ACTION_TYPES.CLAIM_FUND_FETCH_REGISTRATION:
      return update(state, {
        registration: {
          $merge: {
            loading: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_FETCH_REGISTRATION_SUCCESS:
    case ACTION_TYPES.CLAIM_FUND_FETCH_REGISTRATION_FAILED:
      return update(state, {
        registration: {
          $merge: {
            data: payload.data,
            loading: false,
            success: payload.success,
            error: payload.error,
            fetched: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_SELECT_BANK_RESULT:
      return update(state, {
        selectBank: {
          $merge: {
            bank_code: payload.bank_code,
            bank_name: payload.bank_name,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_INQUIRY:
      return update(state, {
        inquiry: {
          $merge: {
            loading: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_INQUIRY_SUCCESS:
    case ACTION_TYPES.CLAIM_FUND_INQUIRY_FAILED:
      return update(state, {
        inquiry: {
          $merge: {
            loading: false,
            data: payload.data,
            success: payload.success,
            submitted: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_ADD_USER_DATA:
      return update(state, {
        addUserData: {
          $merge: {
            loading: true,
          },
        },
      });
    case ACTION_TYPES.CLAIM_FUND_ADD_USER_DATA_SUCCESS:
    case ACTION_TYPES.CLAIM_FUND_ADD_USER_DATA_FAILED:
      return update(state, {
        addUserData: {
          $merge: {
            loading: false,
            success: payload.success,
            submitted: true,
          },
        },
      });
    default:
      return state;
  }
};
